import { externalAuthResetAction, externalAuthStartedAction, externalAuthUpdateAction, externalAuthSuccessAction, externalAuthErrorAction } from "./actions.js";
function addExternalAuthReducers(builder) {
  return builder.addCase(externalAuthResetAction, (state) => {
    state.eventType = "externalAuth";
    delete state.status;
    delete state.authContext;
    delete state.error;
  }).addCase(externalAuthStartedAction, (state, { payload }) => {
    state.eventType = "externalAuth";
    state.status = "pending";
    state.authContext = payload;
    delete state.error;
  }).addCase(externalAuthUpdateAction, (state, { payload }) => {
    state.eventType = "externalAuth";
    state.status = "pending";
    Object.entries(payload).forEach(([key, val]) => {
      state[key] = val;
    });
  }).addCase(externalAuthSuccessAction.pending, (state) => {
    state.eventType = "externalAuth";
    state.status = "pending";
  }).addCase(externalAuthSuccessAction.fulfilled, (state, { payload }) => {
    state.eventType = "externalAuth";
    state.status = "success";
    Object.entries(payload).forEach(([key, val]) => {
      state[key] = val;
    });
  }).addCase(externalAuthErrorAction, (state, { payload }) => {
    state.eventType = "externalAuth";
    state.status = "error";
    state.error = payload;
  });
}
export {
  addExternalAuthReducers
};
//# sourceMappingURL=external-auth-reducers.js.map
